export var InternalErrorType;
(function (InternalErrorType) {
    InternalErrorType["INVALID_EMAIL"] = "invalid_email";
    InternalErrorType["INVALID_DATE"] = "invalid_date";
    InternalErrorType["INVALID_DATE_RANGE"] = "invalid_date_range";
    InternalErrorType["INVALID_MIN_LENGTH"] = "invalid_min_length";
    InternalErrorType["INVALID_OPTION"] = "INVALID_OPTION";
})(InternalErrorType || (InternalErrorType = {}));
//# sourceMappingURL=internalErrors.js.map